import React from 'react';

export default function RoundGlassesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Left lens */}
      <circle cx="13" cy="20" r="7" stroke="#888888" strokeWidth="1.5" fill="none" />
      {/* Right lens */}
      <circle cx="27" cy="20" r="7" stroke="#888888" strokeWidth="1.5" fill="none" />
      {/* Bridge */}
      <path d="M20 20C19 18 21 18 20 20" stroke="#888888" strokeWidth="1.5" fill="none" />
      <line x1="20" y1="19" x2="20" y2="19" stroke="#888888" strokeWidth="1.5" />
      <path d="M20 19C18 17 22 17 20 19" stroke="#888888" strokeWidth="1.2" fill="none" />
      {/* Left temple arm */}
      <line x1="6" y1="18" x2="2" y2="17" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      {/* Right temple arm */}
      <line x1="34" y1="18" x2="38" y2="17" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      {/* Lens reflection */}
      <path d="M10 16C11 15 12 16 11 17" stroke="white" strokeWidth="0.8" opacity="0.4" fill="none" />
      <path d="M24 16C25 15 26 16 25 17" stroke="white" strokeWidth="0.8" opacity="0.4" fill="none" />
    </svg>
  );
}
